/* =========================================================================
   RELOAD — mobile.js
   Behaviour for the phone layout in mobile.css: the bottom dock, the search
   sheet with live results, the palette buttons in the footer and the swipe
   gallery with a full-screen viewer on product pages.
   Nothing here runs a visible change on desktop.
   ========================================================================= */
(function () {
  'use strict';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var phone = window.matchMedia('(max-width:860px)');
  var body = document.body;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function money(amount) {
    var n = Number(amount);
    if (isNaN(n)) return '';
    var txt = n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var fmt = window.RELOAD_MONEY_FORMAT || '{{amount}}';
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, txt).replace(/<[^>]*>/g, '');
  }

  /* ------------------------------------------------------------- menu */
  var navEl = document.getElementById('mobileNav');
  var menuBtn = document.getElementById('mMenuBtn');
  var burger = document.getElementById('burgerBtn');

  function menuOpen() { return !!(navEl && navEl.classList.contains('open')); }
  function syncMenu() {
    var open = menuOpen();
    body.classList.toggle('m-menu-open', open);
    if (menuBtn) menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  if (menuBtn && navEl) {
    menuBtn.addEventListener('click', function () {
      closeSearch();
      if (burger) burger.click();              /* theme.js owns open/close */
      else navEl.classList.toggle('open');
      syncMenu();
    });
    new MutationObserver(syncMenu).observe(navEl, { attributes: true, attributeFilter: ['class'] });
  }

  /* ------------------------------------------------------------- dock */
  var dock = document.getElementById('mDock');
  if (dock) {
    var lastY = window.scrollY, ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var y = window.scrollY;
        var nearEnd = window.innerHeight + y > document.documentElement.scrollHeight - 40;
        if (y < 80 || nearEnd) dock.classList.remove('tuck');
        else if (y > lastY + 6) dock.classList.add('tuck');
        else if (y < lastY - 6) dock.classList.remove('tuck');
        lastY = y;
        ticking = false;
      });
    }, { passive: true });
  }

  /* the dock's bag count follows the header badge that theme.js refreshes */
  var badge = document.getElementById('cartCount');
  var dockCount = document.getElementById('mDockCount');
  if (badge && dockCount) {
    var mirror = function () { dockCount.textContent = badge.textContent.trim() || '0'; };
    mirror();
    new MutationObserver(mirror).observe(badge, { childList: true, characterData: true, subtree: true });
  }

  /* ----------------------------------------------------------- search */
  var sheet = document.getElementById('mSearch');
  var openBtn = document.getElementById('mSearchOpen');
  var input = document.getElementById('mSearchInput');
  var closeBtn = document.getElementById('mSearchClose');
  var closeLabel = document.getElementById('mSearchCloseLabel');
  var idle = document.getElementById('mSearchIdle');
  var statusEl = document.getElementById('mSearchStatus');
  var grid = document.getElementById('mSearchGrid');
  var allLink = document.getElementById('mSearchAll');
  var timer = null, seq = 0, lastFocus = null;

  function openSearch() {
    if (!sheet) return;
    if (menuOpen() && burger) burger.click();
    lastFocus = document.activeElement;
    sheet.hidden = false;
    body.classList.add('m-search-open');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
    setTimeout(function () { input && input.focus(); }, 30);
  }
  function closeSearch() {
    if (!sheet || sheet.hidden) return;
    sheet.hidden = true;
    body.classList.remove('m-search-open');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
    if (input) input.blur();
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function setCloseLabel() {
    if (!closeBtn || !closeLabel) return;
    closeLabel.textContent = input.value ? closeBtn.dataset.clear : closeBtn.dataset.close;
  }
  function card(p) {
    var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
    if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=480';
    return '<a class="ms-card' + (p.available === false ? ' sold' : '') + '" href="' + esc(p.url) + '">' +
      '<div class="ms-img">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</div>' +
      '<div class="ms-brand">' + esc(p.vendor) + '</div>' +
      '<div class="ms-title">' + esc(p.title) + '</div>' +
      '<div class="ms-price">' + esc(money(p.price)) + '</div></a>';
  }
  function run(q) {
    var my = ++seq;
    if (!q) {
      grid.innerHTML = '';
      statusEl.textContent = '';
      allLink.hidden = true;
      idle.hidden = false;
      return;
    }
    idle.hidden = true;
    statusEl.textContent = statusEl.dataset.loading;
    var url = ROOT + 'search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last';
    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (my !== seq) return;
        var list = (d && d.resources && d.resources.results && d.resources.results.products) || [];
        grid.innerHTML = list.map(card).join('');
        statusEl.textContent = list.length ? '' : statusEl.dataset.empty;
        allLink.hidden = !list.length;
        allLink.href = ROOT + 'search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last';
        allLink.innerHTML = '<span>' + esc(allLink.dataset.label) + ' — “' + esc(q) + '”</span><span>&#8594;</span>';
      })
      .catch(function () { if (my === seq) statusEl.textContent = ''; });
  }
  if (sheet && openBtn && input) {
    openBtn.addEventListener('click', openSearch);
    closeBtn.addEventListener('click', function () {
      if (input.value) { input.value = ''; setCloseLabel(); run(''); input.focus(); }
      else closeSearch();
    });
    input.addEventListener('input', function () {
      setCloseLabel();
      clearTimeout(timer);
      var q = input.value.trim();
      timer = setTimeout(function () { run(q); }, 180);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !sheet.hidden) closeSearch();
    });
    /* the old header search links to /search; on a phone open the sheet */
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a.nav-search-mobile');
      if (a && phone.matches) { e.preventDefault(); openSearch(); }
    });
  }

  /* ---------------------------------------------- footer palette buttons */
  (function () {
    var opts = document.querySelectorAll('.fp-opt[data-pal]');
    if (!opts.length) return;
    function paint() {
      var light = body.classList.contains('light');
      opts.forEach(function (b) {
        var on = (b.dataset.pal === 'light') === light;
        b.classList.toggle('on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    opts.forEach(function (b) {
      b.addEventListener('click', function () {
        var target = document.getElementById(b.dataset.pal === 'light' ? 'palLight' : 'palDark');
        if (target) target.click();
        paint();
      });
    });
    paint();
    new MutationObserver(paint).observe(body, { attributes: true, attributeFilter: ['class'] });
  })();

  /* ----------------------------------------------- product swipe gallery */
  (function () {
    var thumbs = document.getElementById('pdpThumbs');
    var main = document.getElementById('pdpMain');
    var gallery = main && main.closest('.pdp-gallery');
    if (!gallery) return;

    var srcs = [].slice.call(thumbs ? thumbs.querySelectorAll('.pdp-thumb') : [])
      .map(function (t) { return t.getAttribute('data-full'); })
      .filter(Boolean);
    if (!srcs.length) {
      var only = main.querySelector('img');
      if (only) srcs = [only.currentSrc || only.src];
    }
    if (!srcs.length) return;
    var alt = (main.querySelector('img') || {}).alt || '';
    var hintText = 'Tap to zoom · pinch';

    /* inline swipe strip */
    var gal = document.createElement('div');
    gal.className = 'm-gal';
    var tag = main.querySelector('.tag');
    gal.innerHTML =
      (tag ? tag.outerHTML : '') +
      '<div class="m-gal-track">' + srcs.map(function (s, i) {
        return '<button type="button" class="m-gal-slide" data-i="' + i + '" aria-label="' + esc(alt) + ' ' + (i + 1) + '">' +
          '<img src="' + esc(s) + '" alt="' + (i ? '' : esc(alt)) + '"' + (i ? ' loading="lazy"' : ' fetchpriority="high"') + '></button>';
      }).join('') + '</div>' +
      '<div class="m-gal-meta"><span class="m-gal-n">1 / ' + srcs.length + '</span></div>' +
      (srcs.length > 1 ? '<div class="m-gal-dots">' + srcs.map(function (_, i) { return '<i' + (i ? '' : ' class="on"') + '></i>'; }).join('') + '</div>' : '');
    gallery.parentNode.insertBefore(gal, gallery);

    var track = gal.querySelector('.m-gal-track');
    var nEl = gal.querySelector('.m-gal-n');
    var dots = [].slice.call(gal.querySelectorAll('.m-gal-dots i'));
    function current() { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }
    track.addEventListener('scroll', function () {
      var i = current();
      nEl.textContent = (i + 1) + ' / ' + srcs.length;
      dots.forEach(function (d, k) { d.classList.toggle('on', k === i); });
    }, { passive: true });

    /* full-screen viewer */
    var viewer = document.createElement('div');
    viewer.className = 'm-viewer';
    viewer.setAttribute('role', 'dialog');
    viewer.setAttribute('aria-modal', 'true');
    var closeTxt = document.documentElement.lang === 'tr' ? 'Kapat' : 'Close';
    viewer.innerHTML =
      '<div class="mv-top"><span class="mv-count">1 / ' + srcs.length + '</span>' +
      '<button type="button" class="mv-close">' + closeTxt + ' ( &#215; )</button></div>' +
      '<div class="mv-track">' + srcs.map(function (s) {
        var big = s.replace(/([?&])width=\d+/, '$1width=2000');
        return '<div class="mv-slide"><img src="' + esc(big) + '" alt="" draggable="false" loading="lazy"></div>';
      }).join('') + '</div>' +
      '<div class="mv-hint">' + hintText + '</div>';
    body.appendChild(viewer);

    var vTrack = viewer.querySelector('.mv-track');
    var vCount = viewer.querySelector('.mv-count');
    var slides = [].slice.call(viewer.querySelectorAll('.mv-slide'));
    var states = slides.map(function () { return { s: 1, x: 0, y: 0 }; });

    function vIndex() { return Math.round(vTrack.scrollLeft / Math.max(1, vTrack.clientWidth)); }
    vTrack.addEventListener('scroll', function () {
      vCount.textContent = (vIndex() + 1) + ' / ' + srcs.length;
    }, { passive: true });

    function imgOf(i) { return slides[i].querySelector('img'); }
    function apply(i, animate) {
      var st = states[i], img = imgOf(i);
      img.classList.toggle('anim', !!animate);
      img.style.transform = 'translate(' + st.x + 'px,' + st.y + 'px) scale(' + st.s + ')';
      var z = st.s > 1.01;
      slides[i].classList.toggle('zoomed', z);
      viewer.classList.toggle('zoomed', z);
      vTrack.classList.toggle('locked', z);
    }
    function clamp(i) {
      var st = states[i], img = imgOf(i), box = slides[i];
      var w = img.offsetWidth * st.s, h = img.offsetHeight * st.s;
      var mx = Math.max(0, (w - box.clientWidth) / 2), my = Math.max(0, (h - box.clientHeight) / 2);
      st.x = Math.min(mx, Math.max(-mx, st.x));
      st.y = Math.min(my, Math.max(-my, st.y));
    }
    function reset(i, animate) { states[i] = { s: 1, x: 0, y: 0 }; apply(i, animate); }
    /* zoom so the point under (px,py) — measured from the slide centre — stays put */
    function zoomAt(i, s1, px, py) {
      var st = states[i];
      var qx = (px - st.x) / st.s, qy = (py - st.y) / st.s;
      st.s = s1; st.x = px - s1 * qx; st.y = py - s1 * qy;
      clamp(i);
    }

    function openViewer(i) {
      viewer.classList.add('open');
      body.classList.add('m-search-open');          /* reuses the scroll lock */
      slides.forEach(function (_, k) { reset(k); });
      requestAnimationFrame(function () {
        vTrack.scrollLeft = i * vTrack.clientWidth;
        vCount.textContent = (i + 1) + ' / ' + srcs.length;
      });
    }
    function closeViewer() {
      var i = vIndex();
      viewer.classList.remove('open', 'zoomed');
      body.classList.remove('m-search-open');
      track.scrollLeft = i * track.clientWidth;
    }
    viewer.querySelector('.mv-close').addEventListener('click', closeViewer);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && viewer.classList.contains('open')) closeViewer();
    });
    track.addEventListener('click', function (e) {
      var s = e.target.closest('.m-gal-slide');
      if (s) openViewer(Number(s.dataset.i));
    });

    /* gestures: tap toggles zoom at the finger, one finger drags the picture
       the same way the finger moves, two fingers pinch */
    slides.forEach(function (slide, i) {
      var t0 = null, start = null, pinch = null, moved = false;

      function local(t) {
        var r = slide.getBoundingClientRect();
        return { x: t.clientX - r.left - r.width / 2, y: t.clientY - r.top - r.height / 2 };
      }
      function dist(a, b) { return Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY); }

      slide.addEventListener('touchstart', function (e) {
        moved = false;
        var st = states[i];
        if (e.touches.length === 2) {
          var m = local({ clientX: (e.touches[0].clientX + e.touches[1].clientX) / 2,
                          clientY: (e.touches[0].clientY + e.touches[1].clientY) / 2 });
          pinch = { d: dist(e.touches[0], e.touches[1]), s: st.s, qx: (m.x - st.x) / st.s, qy: (m.y - st.y) / st.s };
          start = null;
        } else if (e.touches.length === 1) {
          t0 = Date.now();
          start = { cx: e.touches[0].clientX, cy: e.touches[0].clientY, x: st.x, y: st.y };
        }
      }, { passive: true });

      slide.addEventListener('touchmove', function (e) {
        var st = states[i];
        if (pinch && e.touches.length === 2) {
          e.preventDefault();
          moved = true;
          var s1 = Math.min(4, Math.max(1, pinch.s * dist(e.touches[0], e.touches[1]) / pinch.d));
          var m = local({ clientX: (e.touches[0].clientX + e.touches[1].clientX) / 2,
                          clientY: (e.touches[0].clientY + e.touches[1].clientY) / 2 });
          st.s = s1; st.x = m.x - s1 * pinch.qx; st.y = m.y - s1 * pinch.qy;
          clamp(i); apply(i);
          return;
        }
        if (!start || e.touches.length !== 1) return;
        var dx = e.touches[0].clientX - start.cx, dy = e.touches[0].clientY - start.cy;
        if (Math.abs(dx) > 6 || Math.abs(dy) > 6) moved = true;
        if (st.s > 1.01) {
          e.preventDefault();
          st.x = start.x + dx; st.y = start.y + dy;   /* the picture follows the finger */
          clamp(i); apply(i);
        }
      }, { passive: false });

      slide.addEventListener('touchend', function (e) {
        if (pinch) {
          if (e.touches.length < 2) {
            pinch = null;
            if (states[i].s < 1.05) reset(i, true);
            if (e.touches.length === 1) {
              var st = states[i];
              start = { cx: e.touches[0].clientX, cy: e.touches[0].clientY, x: st.x, y: st.y };
            }
          }
          return;
        }
        if (!start) return;
        var quick = Date.now() - t0 < 350;
        if (!moved && quick && e.changedTouches.length) {
          var p = local(e.changedTouches[0]);
          if (states[i].s > 1.01) reset(i, true);
          else { zoomAt(i, 2.5, p.x, p.y); apply(i, true); }
        }
        start = null;
      });

      /* mouse fallback for small desktop windows */
      slide.addEventListener('click', function (e) {
        if (window.matchMedia('(pointer:coarse)').matches) return;
        var p = local(e);
        if (states[i].s > 1.01) reset(i, true);
        else { zoomAt(i, 2.5, p.x, p.y); apply(i, true); }
      });
    });
  })();
})();
